import {types} from './types';

const setGetListExchangeRatesAction = (payload) => {
    return {
        type: types.SET_LIST_EXCHANGE_RATES,
        payload,
      }
}

const setGetViewExchangeRatesAction = (payload) => {
  return {
    type: types.SET_VIEW_EXCHANGE_RATES,
    payload
  }
}
export {
  setGetListExchangeRatesAction,
  setGetViewExchangeRatesAction
}
